/* Home section stacking uses native scrolling, with no scroll handler. */
(function () {
  'use strict';
  if (!document.body.classList.contains('template-index')) return;

  var main = document.getElementById('MainContent');
  if (!main) return;
  var sections = [];
  var frame = 0;
  var observer = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;

  function measure() {
    frame = 0;
    var viewport = document.documentElement.clientHeight;
    var offsets = sections.map(function (section) {
      // Read tall sections fully before the next one starts covering them.
      return Math.min(0, viewport - section.getBoundingClientRect().height);
    });
    sections.forEach(function (section, index) {
      section.style.setProperty('--lg-stack-top', offsets[index] + 'px');
    });
  }

  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(measure);
  }

  function refresh() {
    if (observer) observer.disconnect();
    sections.forEach(function (section) {
      section.style.removeProperty('--lg-stack-top');
    });
    sections = Array.prototype.filter.call(main.children, function (section) {
      return section.classList.contains('shopify-section') &&
        section.querySelector('[data-lg-stack-under]');
    });
    sections.forEach(function (section) {
      if (observer) observer.observe(section);
    });
    schedule();
  }

  refresh();
  window.addEventListener('resize', schedule, { passive: true });
  main.addEventListener('load', schedule, true);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);
  document.addEventListener('shopify:section:reorder', refresh);
})();
